exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containers[data-v-48d074ac]{padding:.2rem}.box[data-v-48d074ac]{padding:.4rem;box-shadow:0 0 .12rem 0 #efefef}.figure-input[data-v-48d074ac]{font-size:.73rem;margin-top:.2rem;padding-bottom:.1rem}input[data-v-48d074ac]{box-sizing:border-box;width:100%}.btns[data-v-48d074ac]{padding:.32rem;margin-top:.4rem}.btn[data-v-48d074ac]{width:100%;height:1rem;line-height:1rem;border-radius:.04rem}.extractRecord-btn[data-v-48d074ac]{position:absolute;text-decoration:underline;bottom:1.2rem;width:100%;color:#3d3d3d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48d074ac","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/my/extract/extract.vue
// module id = 311
// module chunks = 0